import { useEffect, useState } from "react";
import PinLogin from "./PinLogin";
import Dashboard from "./Dashboard";
import ProjectEditor from "./ProjectEditor";
import PostEditor from "./PostEditor";
import EventEditor from "./EventEditor";
import { adminFetch, getToken } from "../../lib/adminApi";

export default function AdminPage() {
  const [auth, setAuth] = useState(null); // null = checking, false = logged out, true = in
  const [view, setView] = useState({ name: "list", kind: null, id: null });

  useEffect(() => {
    if (!getToken()) {
      setAuth(false);
      return;
    }
    adminFetch("/api/admin/me")
      .then((r) => setAuth(r.ok))
      .catch(() => setAuth(false));
  }, []);

  if (auth === null) {
    return (
      <div className="flex min-h-svh items-center justify-center bg-ink">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-paper/50">
          Checking access…
        </p>
      </div>
    );
  }

  if (!auth) {
    return <PinLogin onSuccess={() => setAuth(true)} />;
  }

  if (view.name === "editor") {
    const back = () => setView({ name: "list", kind: null, id: null });
    return view.kind === "post" ? (
      <PostEditor postId={view.id} onBack={back} />
    ) : view.kind === "event" ? (
      <EventEditor eventId={view.id} onBack={back} />
    ) : (
      <ProjectEditor projectId={view.id} onBack={back} />
    );
  }

  return (
    <Dashboard
      onNew={(kind) => setView({ name: "editor", kind, id: null })}
      onEdit={(kind, id) => setView({ name: "editor", kind, id })}
      onLogout={() => {
        localStorage.removeItem("tripleo_admin_token");
        setAuth(false);
      }}
    />
  );
}
